var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import FormControl from '../FormControl';
import FormHelperText from '../FormHelperText';
import Input from '../Input';
import InputLabel from '../InputLabel';
import MUIMenuItem from '../MenuItem';
import MUISelect from '../Select';
var Select = function (_a) {
    var error = _a.error, value = _a.value, label = _a.label, name = _a.name, helperText = _a.helperText, options = _a.options, required = _a.required, fullWidth = _a.fullWidth, disabled = _a.disabled, className = _a.className, readOnly = _a.readOnly, _b = _a.onChange, onChange = _b === void 0 ? function () { return undefined; } : _b, _c = _a.richContent, richContent = _c === void 0 ? false : _c, inputProps = _a.inputProps, classes = _a.classes, rest = __rest(_a, ["error", "value", "label", "name", "helperText", "options", "required", "fullWidth", "disabled", "className", "readOnly", "onChange", "richContent", "inputProps", "classes"]);
    var renderedOptions = options.map(function (option) {
        if (richContent) {
            return (React.createElement(MUIMenuItem, { key: option.value, value: option.value, "data-test-locator": option.dataTestLocator || null }, option.title || option.value));
        }
        return (React.createElement("option", { key: option.value, value: option.value, "data-test-locator": option.dataTestLocator || null }, option.title || option.value));
    });
    return (React.createElement(FormControl, __assign({ className: className, fullWidth: fullWidth, required: required, error: Boolean(error) }, rest),
        label && (React.createElement(InputLabel, { shrink: 
            // because we have many places setting the first option for our select
            // we need to somehow prevent the user of this input to decide if he should or not
            // shrink the label
            // When you already selected a value just shrink the value
            // if not, check if the given options include option with value empty and title
            // it means the user is given the component a default option which should be rendered
            // and not be overlapped by the label
            // Be careful with a value that equals to 0 (zero), as that will make the next assertion false.
            value
                ? true
                : options.some(function (option) { return option.value === '' && option.title !== ''; }), htmlFor: name }, label)),
        React.createElement(MUISelect, { native: !richContent && !readOnly, value: value, 
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            onChange: onChange, name: name, input: React.createElement(Input, { id: name, readOnly: readOnly }), disabled: disabled, inputProps: inputProps || undefined, "data-test-locator": "Select Component", classes: classes }, renderedOptions),
        helperText && React.createElement(FormHelperText, null, helperText),
        error && React.createElement(FormHelperText, null, error)));
};
export default Select;
//# sourceMappingURL=Select.js.map